
import React from 'react';
import { withTranslation } from 'react-i18next';
import { AbstractLayout } from '../../../index';
import {
  Footer,
  Header,
} from './index';

class LegacyLayout extends AbstractLayout {
  renderChildren () {
    return (<React.Fragment>
      { this.props.showHeader ? <Header /> : null }
      { this.props.children }
      { this.props.showFooter ? <Footer /> : null }
    </React.Fragment>);
  }
}

LegacyLayout.propTypes = {
  ...AbstractLayout.propTypes,
};

LegacyLayout.defaultProps = {
  ...AbstractLayout.defaultProps,
};

const Layout = withTranslation()(LegacyLayout);
export default Layout;
